module.exports = __webpack_public_path__ + "img/hero-prisons.a478066e.jpg";